import React from 'react';
import { Row } from 'antd';

import FormInput from 'components/FormInput';

const TabPaymentSupplierInvoice = () => (
  <Row>
    <FormInput col xs={24} lg={12} name="externalreference" />
  </Row>
);

export default TabPaymentSupplierInvoice;
